import { ArrayOrValue, ValueOf } from '@web/types'

import routes from './constants/routes'
import { pipe } from './pipe'

const slashToRegex = (path: string): string => path.replace(/\//g, '\\/')

const pathParamsToRegex = (path: string): string => path.replace(/:[^/]+/g, '[^/]+')

const addStartRegex = (path: string): string => `^${path}`

const addEndRegex = (path: string): string => `${path}$`

const extractOnlyPath = (path: string): string => path.split('?')[0]

export const isMatchPath = <Path extends ValueOf<typeof routes>>(
  currentPath: string,
  {
    path,
    exact = false,
  }: {
    path: ArrayOrValue<Path>
    exact?: boolean
  },
) => {
  const pathArray = Array.isArray(path) ? path : [path]

  const regexArray = pathArray.map(path => {
    const regex = pipe(path)
      .and(extractOnlyPath)
      .and(slashToRegex)
      .and(pathParamsToRegex)
      .and(addStartRegex)
      .and(addStartRegex)
      .on(exact, addEndRegex)
      .get()

    return new RegExp(regex)
  })

  return regexArray.some(regex => regex.test(currentPath))
}
